import { render, staticRenderFns } from "./HistoricoDeUploads.vue?vue&type=template&id=fb294612"
import script from "./HistoricoDeUploads.vue?vue&type=script&lang=js"
export * from "./HistoricoDeUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports